/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';
import * as moment from 'moment';
import 'moment-timezone';

import {
  getBudgetNetworkTimezone,
  isCurrentBudgetPeriod,
  networkDayFromApiDate,
  normalizeBudgetDay,
  pickerDateForNetworkDay
} from './order-budget-utils';

export function updateBudgets(ctrl: any, obj?: any): void {
  const workingObj = obj || ctrl.editingModel || ctrl.model || {};
  const budgets = _.cloneDeep(workingObj.budget) || [];
  const adnTimeShifter = ctrl.adnTimeShifter;
  const networkTimezone = adnTimeShifter
    ? getBudgetNetworkTimezone(adnTimeShifter)
    : (ctrl.LocalNetworkProfile.get('timeZone') || 'utc');

  if (budgets.length && workingObj.startDate) {
    const objectStartDay = adnTimeShifter
      ? networkDayFromApiDate(workingObj.modStartDate || workingObj.startDate, adnTimeShifter)
      : moment(workingObj.modStartDate || workingObj.startDate).tz(networkTimezone).format('YYYY-MM-DD');
    const budgetStartDay = normalizeBudgetDay(budgets[0].startDay, adnTimeShifter, networkTimezone);
    if (objectStartDay && budgetStartDay && objectStartDay !== budgetStartDay) {
      budgets[0].startDay = objectStartDay;
    }
  }

  if (budgets.length && workingObj.endDate) {
    const objectEndDay = adnTimeShifter
      ? networkDayFromApiDate(workingObj.modEndDate || workingObj.endDate, adnTimeShifter)
      : moment(workingObj.modEndDate || workingObj.endDate).tz(networkTimezone).format('YYYY-MM-DD');
    const budgetEndDay = normalizeBudgetDay(budgets[budgets.length - 1].endDay, adnTimeShifter, networkTimezone);
    if (objectEndDay && budgetEndDay && objectEndDay !== budgetEndDay) {
      budgets[budgets.length - 1].endDay = objectEndDay;
    }
  }

  _.forEach(budgets, (b: any) => {
    const startDay = normalizeBudgetDay(b.startDay, adnTimeShifter, networkTimezone);
    const endDay = normalizeBudgetDay(b.endDay, adnTimeShifter, networkTimezone);
    if (startDay) {
      b.startDay = startDay;
      b.modStartDay = pickerDateForNetworkDay(startDay, networkTimezone, 'start');
    }
    if (endDay) {
      b.endDay = endDay;
      b.modEndDay = pickerDateForNetworkDay(endDay, networkTimezone, 'end');
    }
    if (startDay && endDay && isCurrentBudgetPeriod(startDay, endDay, networkTimezone)) {
      ctrl.currentBudgetPeriod = b;
    }
  });
  ctrl.uiBudgets = budgets;
  const targetModel = ctrl.editingModel || ctrl.model;
  if (targetModel) {
    targetModel.budgetRollover = _.isBoolean(workingObj.budgetRollover) ? workingObj.budgetRollover : true;
  }
}
